import React, { FC } from 'react';
import { HeaderProps } from './types';
import { AtlassianNavigation } from '@atlaskit/atlassian-navigation';
import { AtlassianIcon, AtlassianLogo } from '@atlaskit/logo';
import { Anchor, Box, Inline, media, Text, xcss } from '@atlaskit/primitives';

const iconStyles = xcss({
  display: 'none',
  [media.above.xs]: { display: 'flex' },
  [media.above.sm]: { display: 'none' },
});

const logoStyles = xcss({
  display: 'none',
  [media.above.sm]: { display: 'flex' },
});

const headlineStyles = xcss({
  display: 'none',
  [media.above.md]: { display: 'flex' },
});

const CustomProductHome = () => (
  <Inline space={'space.150'} alignBlock={'center'}>
    <Anchor href='https://atlassian.com' target='_blank' rel='noreferrer'>
      <Box xcss={iconStyles}>
        <AtlassianIcon size='small' appearance='brand' testId='product-home-icon' />
      </Box>
      <Box xcss={logoStyles}>
        <AtlassianLogo size='small' appearance='brand' testId='product-home-logo' />
      </Box>
    </Anchor>
    <Box xcss={headlineStyles}>
      <Text size={'large'} testId={'product-home-title'}>
        Email and Privacy Preferences
      </Text>
    </Box>
  </Inline>
);

const Header: FC<HeaderProps> = ({ headerContent }) => {
  return (
    <AtlassianNavigation
      label='Email and Privacy Preferences'
      primaryItems={[]}
      renderProductHome={CustomProductHome}
      renderProfile={headerContent}
      testId='preferences-center'
    />
  );
};

export default Header;
